import { useState } from "react";
import { months } from "../../const";
import { arrowVertical } from "../../ui-icons/icons";
import { TooltipItem } from "src/utils/Tooltip";

const minYear = 2025;
const minMonth = 1;

type DatePickerProps = {
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number | null>>;
  month: number;
  setMonth: React.Dispatch<React.SetStateAction<number | null>>;
  isSummary: boolean;
  currentDate: unknown;
};

function DatePicker({ year, setYear, month, currentDate, setMonth }: DatePickerProps) {
  const [isOpenCalendar, setIsOpenCalendar] = useState<boolean>(false);

  const currentMonth = currentDate?.month;

  const currentYear = currentDate?.year;

  const handleButtonNextMonth = () => {
    let nextMonth = month + 1;
    let nextYear = year;

    if (nextMonth > 12) {
      nextMonth = 1;
      nextYear += 1;
    }

    setMonth(nextMonth);
    setYear(nextYear);
  };

  const handleButtonPrevMonth = () => {
    let prevMonth = month - 1;
    let prevYear = year;

    if (prevMonth === 0) {
      prevMonth = 12;
      prevYear -= 1;
    }

    setMonth(prevMonth);
    setYear(prevYear);
  };

  const handleButtonNextYear = () => {
    const nextDate = new Date(year, month);
    nextDate.setFullYear(nextDate.getFullYear() + 1);
    setYear(nextDate.getFullYear());
  };

  const handleButtonPrevYear = () => {
    const prevDate = new Date(year, month);
    prevDate.setFullYear(prevDate.getFullYear() - 1);
    setYear(prevDate.getFullYear());
  };

  const handleRadioMonthChange = (index: number) => {
    setMonth(index + 1);
  };

  const isDisabledPrevMonth = () => {
    return year === minYear && month <= minMonth;
  };

  const isDisabledNextMonth = () => {
    return (
      year > currentYear ||
      (year === currentYear && month >= currentMonth)
    );
  };

  const isDisabledNextYear = () => {
    return year >= currentYear;
  };

  const isDisabledPrevYear = () => {
    return year <= minYear;
  };

  return (
    <>
      <button
        className="mr-1 p-1 disabled:opacity-50"
        type="button"
        onClick={handleButtonPrevMonth}
        disabled={isDisabledPrevMonth()}
      >
        <div className="leading-none translate-y-[2px]">
          <TooltipItem position="top" tooltipsText='Предыдущий месяц'>
            {arrowVertical}
          </TooltipItem>
        </div>
      </button>

      <button
        className="p-1 disabled:opacity-50"
        type="button"
        onClick={handleButtonNextMonth}
        disabled={isDisabledNextMonth()}
      >
        <div className="rotate-180 origin-center leading-none">
          <TooltipItem className="rotate-180 translate-y-[275%]" position="top" tooltipsText='Следующий месяц'>
            {arrowVertical}
          </TooltipItem>
        </div>
      </button>

      <div className="relative w-[120px]">
        <span
          className="cursor-pointer"
          onClick={() => setIsOpenCalendar(!isOpenCalendar)}
        >
          {months[month - 1]} {year}
        </span>

        {isOpenCalendar && (
          <div className="absolute right-0 top-[calc(100%+8px)] z-20 w-[320px] rounded-md bg-[#fff] p-2 shadow">
            <div className="mb-2 flex justify-center gap-2">
              <button
                className="p-1 disabled:opacity-50"
                type="button"
                onClick={handleButtonPrevYear}
                disabled={isDisabledPrevYear()}
              >
                <div>
                  {arrowVertical}
                </div>
              </button>

              <span>{year}</span>

              <button
                className="p-1 disabled:opacity-50"
                type="button"
                onClick={handleButtonNextYear}
                disabled={isDisabledNextYear()}
              >
                <div className="rotate-180">
                  {arrowVertical}
                </div>
              </button>
            </div>

            <div className="grid grid-cols-3">
              {months.map((el, index) => (
                <label className="radio-button" key={index}>
                  <input
                    className="visually-hidden"
                    type="radio"
                    name="months"
                    disabled={(index + 1 > currentMonth && year === currentYear) || (year === minYear && index + 1 < minMonth)}
                    value={el}
                    checked={months[month - 1] === el}
                    onChange={() => {
                      handleRadioMonthChange(index);
                      setIsOpenCalendar(!isOpenCalendar);
                    }}
                  />
                  <div className="cursor-pointer rounded-md px-3 py-2 text-center">
                    {el}
                  </div>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DatePicker;
